<div placeholder (resize)="update(false)" (modify)="update(true)"><ng-content></ng-content></div>
